import React, { useLayoutEffect, useEffect, useState, useRef, useContext} from "react";
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

interface ComponentState {
   items: any
}

class FilterPanel extends React.Component<any, ComponentState> {
    selectedUsers = [];
    loggedInUser = null;
    constructor(props:any) {
        super(props);
        this.setUserCalender = this.setUserCalender.bind(this);
        if(props?.selectedUsers) {
            this.selectedUsers = props?.selectedUsers;
        } else {
            this.selectedUsers = store.getState().CommunicationCycleReducer.selectedUsers;
        }
        this.loggedInUser = props?.loggedInUser;
    }

        setUserCalender=(data) => {
            store.dispatch( setSelectedUsers([...data]) );
            if(this.props?.viewType == "schedule") {
                if(this.props?.onUserSelectEvent) {
                    this.props?.onUserSelectEvent(data);
                }
            } else {
            store.dispatch( getTasks({users:data, viewType: this.props?.viewType}) )
            }
         }


    render() {
        const {users} = this.props;
        return (
            <div className="flex items-center">


     <Listbox value={((this.selectedUsers && this.selectedUsers.length > 0) ? this.selectedUsers : [this.loggedInUser])}  by="key" multiple onChange={this.setUserCalender}>
      
      <div className="relative mt-2 h-12 w-full">

       <ListboxButton className="relative w-full h-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
       {this.selectedUsers && this.selectedUsers.length > 0 && 
          <span className="block truncate">{this.selectedUsers.length > 0 && this.selectedUsers.map((selected) => (<span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{selected['fullName']}</span>) )}</span>}
          {this.selectedUsers && this.selectedUsers.length == 0 && <span className="block truncate text-gray-400"><span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{this.loggedInUser['fullName']}</span></span>}
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
          </span>
        </ListboxButton>      
      
        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {users && users.length > 0 && users.map((item) => (
            <Listbox.Option
              key={item.key}
              value={item}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{item.fullName} {(this.loggedInUser.key == item.key) ? "(Huidig ingelogd)" : ""}</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>

            
            </div>
        )
        }
}

export default FilterPanel;